// extracted by mini-css-extract-plugin
module.exports = {"form":"_normal--form--37x28","divider":"_normal--divider--11kvV"};